export const GET_SYSTEM_ALARM_GPS = 'GET_SYSTEM_ALARM_GPS';
export const SYSTEM_ALARM_GPS_UPDATED = 'SYSTEM_ALARM_GPS_UPDATED';